import { Compass, PenTool, LayoutGrid, Rocket } from "lucide-react";
import { motion } from "framer-motion";

const STEPS = [
  {
    n: "01",
    icon: Compass,
    title: "Discover",
    text: "We learn about your business, goals and target audience.",
  },
  {
    n: "02",
    icon: PenTool,
    title: "Plan",
    text: "We strategize and create a clear roadmap for success.",
  },
  {
    n: "03",
    icon: LayoutGrid,
    title: "Design & Build",
    text: "We design and develop a modern, fast and responsive website.",
  },
  {
    n: "04",
    icon: Rocket,
    title: "Launch & Grow",
    text: "We launch your website and help you grow with ongoing support.",
  },
];

export const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-24 lg:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="text-center mb-16">
          <div className="text-xs sm:text-sm tracking-[0.4em] text-[rgb(182,245,0)] font-mono-alt uppercase mb-4">
            Our Process
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white">
            Simple Steps, Big{" "}
            <span className="text-[rgb(182,245,0)]">Results</span>
          </h2>
        </div>

        <div className="relative">
          {/* connecting dashed line */}
          <div
            aria-hidden
            className="hidden lg:block absolute top-10 left-[10%] right-[10%] border-t border-dashed border-[rgba(182,245,0,0.3)]"
          />

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6 relative">
            {STEPS.map((s, i) => {
              const Icon = s.icon;
              return (
                <motion.div
                  key={s.n}
                  data-testid={`process-step-${s.n}`}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.12 }}
                  className="text-center lg:text-left"
                >
                  <div className="mx-auto lg:mx-0 w-20 h-20 rounded-full bg-black border-2 border-[rgba(182,245,0,0.4)] flex items-center justify-center mb-6">
                    <Icon className="w-8 h-8 text-[rgb(182,245,0)]" strokeWidth={1.6} />
                  </div>
                  <div className="font-display text-5xl font-bold text-white/15 mb-2">
                    {s.n}
                  </div>
                  <h3 className="font-display text-2xl font-semibold text-white mb-3">
                    {s.title}
                  </h3>
                  <p className="text-sm text-white/55 leading-relaxed">
                    {s.text}
                  </p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
